import React from 'react'
import styled from 'styled-components'
import { Head } from 'react-static'

import GalleryMainCategory from './GalleryMainCategory'
import steps from '../../../images/zebra2.jpg'

const Wrapper = styled.div`
	width: 100%;
	background-color: #f3f3f3;
	background: url(${steps}) repeat;
	position: relative;
	padding: 40px 25px 1.5em;
	text-align: center;
	min-height: 33em;

	@media screen and (min-width: 501px) and (max-width: 800px) {
		padding: 40px 25px 1.5em;
		text-align: left;
	}

	@media screen and (min-width: 801px) and (max-width: 1919px) {
		padding: 40px 50px 1.5em;
		text-align: left;
	}

	@media screen and (min-width: 1920px) {
		padding: 75px 100px 2.5em;
		text-align: left;
	}
`

export default class GalleryMain extends React.PureComponent {
	componentDidMount() {
		typeof window !== 'undefined' && window.scroll(0, 0)
	}

	render() {
		const { items, category } = this.props
		const itemsArray = category === 'overview' || category === 'instruments' ? Object.entries(items).reverse() : Object.entries(items)
		const catUpper = `${category[0].toUpperCase()}${category.slice(1)}`
		return(
			<Wrapper>
				<Head>
					<title>{`${catUpper} - Gallery`}</title>
					<meta name="description" content={`${catUpper} - Check out the studio gear. New toys continue to appear in the studio courtesy of Bevan who is a one man production line of electronic goodies.`}/>
				</Head>
				{ itemsArray.map((subcategory,i) => (
					<GalleryMainCategory
						key={i}
						subcategory={subcategory}/>
				))}
			</Wrapper>
		)
	}
}


// WEBPACK FOOTER //
// /opt/build/repo/src/components/pages/gallery/GalleryMain.js